"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Collapse = /*#__PURE__*/function () {
  function Collapse(container) {
    _classCallCheck(this, Collapse);

    this.container = container;
    this.header = this.container.querySelector('.collapse-header');
    this.content = this.container.querySelector('.collapse-body');
    this.init();
  }

  _createClass(Collapse, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.header.addEventListener('click', function (event) {
        event.stopPropagation();

        var collapses = _toConsumableArray(document.getElementsByClassName('js-collapse'));

        collapses = collapses.filter(function (el) {
          return el != _this.container;
        });
        collapses.forEach(function (d) {
          d.classList.remove('is-active');
        });

        _this.toggle();
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.container.classList.toggle('is-active');
    }
  }]);

  return Collapse;
}();

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName('js-collapse')) {
    var collapses = _toConsumableArray(document.getElementsByClassName('js-collapse'));

    collapses.forEach(function (d) {
      new Collapse(d);
    });
  }
});